<template>
    <div>
      <gobuy-head :title="$t('Share audit list')" />
      <div class="zhanweifu" style="height: 4.2rem;" v-if="!$IFR.is_iframe"></div>
        <div class="box" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div v-for='(item,index) in shareList' :key='index' class="box_list">
              <div class="box_list_header">
              <img :src="item.image" />
              <div class="comlist_header_rt">
                <div class="header_rt_tit"><span>{{ $t('Share Time') }} </span>{{item.create_time}}</div>
                <div class="header_rt_txt2">{{ $t('Audit status') }}</div>
                <div class="header_rt_txt">{{item.status == 0?$t('Pending approval'):item.status == 1?$t('Approved'):$t('Audit failed')}}</div>
                <div class="header_rt_txt2" v-if="item.status == 2">{{ $t('Reason for failure') }}</div>
                <div class="header_rt_txt" v-if="item.status == 2">{{item.reason}}</div>
              </div>
            </div>
            </div>
            <empty-record v-if='shareList.length <= 0 && !isMore'></empty-record>
        </div>
    </div>
</template>

<script>
import { Toast, Indicator } from "mint-ui";
import EmptyRecord from '../../../components/EmptyRecord'
import { getShareOrderList } from '../../../api/giftcard'
export default {
  name: 'ShareList',
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      pageTotal: 1, // 总页数
      shareList: [] // 商品列表
    }
  },
  components: {
    EmptyRecord,
  },
  mounted(){
    
  },
  methods: {
    loadMore () {
      if(this.loading){
        return
      }
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {

        this.getDataList(true)
      }
    },
    getDataList(){
      Indicator.open()
      getShareOrderList(this.params).then(res => {
        Indicator.close()
        if (res.result.data.length < this.params.per_page) {
          this.isMore = false
        } else {
          this.isMore = true
        }
        if (this.shareList && this.shareList.length) {
          this.shareList = this.shareList.concat(res.result.data)
        } else {
          this.shareList = res.result.data
        }
        this.loading = false
      }).catch(error=> {
        Indicator.close()
        Toast(error.message)
        this.loading = false
      })
    },

  }
}
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  overflow: hidden;
  .box_list {
    background: linear-gradient(180deg, #FFFAF8 0%, #FFD7C5 100%);
    /* box-shadow: 2px 6px 8px 1px rgba(80, 43, 0, 0.09), inset 0px -1px 4px 1px #FFFFFF; */
    width: 100%;
    padding: 10px 20px;
    border-bottom: 1px solid #DDA8A8;

    .box_list_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 90%;
      img {
        width: 110px;
        height: 110px;
        object-fit: contain;
        margin-right: 6px;
        /* 5.86rem */
      }

      .comlist_header_rt {
        text-align: right;
        .header_rt_tit {
          font-size: 14px;
          span {
            font-weight: bold;
          }
        }

        .header_rt_txt {
          font-size: 12px;
        }

        .header_rt_txt2 {
          font-size: 12px;
          font-weight: bold;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
